 require('./form')
riot.tag2('fileinput', '<div class="col-sm-{opts.width2 || \'8\'} col-sm-offset-{opts.width1 || \'4\'}"> <ul class="list-group"> <li each="{file, i in files}" class="list-group-item"> {file.path}<span riot-tag="confirm" onconfirm="{parent.removeFile.bind(null, file)}" class="badge"><i class="fa fa-times"></i></span> </li> </ul> </div> <formgroup onupdate="{opts.onupdate}"> <input id="{parent.opts.id}" name="{parent.opts.name}" type="file" __required="{parent.required}" onchange="{parent.handleChange}" value="{value}" accept="*" class="form-control"> </formgroup>', 'fileinput .filelist .filerow { width: 100%; }', '', function(opts) {
this.files = [];

this.on('update', function() {
  var ref;
  if (opts.files != null) {
    this.files = opts.files;
  }
  return this.required = ((typeof opts !== "undefined" && opts !== null ? opts.isrequired : void 0) != null) && (typeof opts !== "undefined" && opts !== null ? opts.isrequired : void 0) !== false && !((ref = this.files) != null ? ref.length : void 0) ? true : false;
});

this.handleChange = function(arg) {
  var target;
  target = arg.target;
  if (typeof opts.onupdate === "function") {
    opts.onupdate(target.files);
  }
  return setTimeout((function(_this) {
    return function() {
      return target.value = '';
    };
  })(this), 2000);
};

this.removeFile = (function(_this) {
  return function(file) {
    return typeof opts.onremove === "function" ? opts.onremove(file) : void 0;
  };
})(this);
});